/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};


$(document).ready(function() {
	
	"use strict";
	

    $('.main-container section:first-child').addClass('first-child');

    $.stellar({
        horizontalScrolling: false,
        verticalScrolling: true,
        horizontalOffset: 0,
        verticalOffset: 0,
        responsive: true,
        parallaxBackgrounds: true
    });

    $('.fullHeight').each(function(){
		$(this).css('height', $(window).height()-125);
	});

    alignVertical();
   	halfMarginTop();
	
	$(window).resize(function(){
		alignVertical();
		halfMarginTop();
	});

  
  	//Set a class for each full product
  	
    if ($('.product-full-width').length) {
      var count = 0;
      $('.product-full-width .product').each(function(){
        var caption = $(this).find('.product-details');
      	count++;
        if (count%2 == 0) {
        	caption.addClass('right');
        } else {
            caption.addClass('left');
        }
      });
    }
 
  
  	
	
	//Products Grid

	if ($('.products-container').length) {
		$('.products-grid').imagesLoaded( function() {
          $('.products-container').isotope({
            itemSelector: '.product',
            layoutMode: 'fitRows'
          });
        });
	}

	
	//Offscreen cart
  	// Load Ajax cart on open

	if ($('.side-menu-opener').length) {
		$('.side-menu-opener').sidr({
			side: 'right',
			onOpen: ajaxCart.load,
            displace: true,
		    onClose: function() {
		    	//Do something on CLOSE
		    }
		});
	}
  
  	$('.side-menu-closer').on('click', function() {
        	$.sidr('close');
     });

	
	//Hero Slider 

	if ($('.hero-slider').length ) {
      	$('.hero-slider').on('init', function(slick) {
          	$('.hero-loader').fadeOut(1000);
        });
      
    	$('.hero-slider').slick({
    		dots: true,
    		fade: true
    	});
    }


	//Team Carousel

	if ($('.team-carousel').length ) {

		$('.team-carousel').slick({
		  	centerMode: !0,
	        dots: !0,
	        arrows: !1,
	        accessibility: !0,
	        infinite: !0,
	        speed: 650,
	        centerPadding: "500px",
	        cssEase: "ease",
	        slidesToShow: 1,
	        draggable: !0,
	        responsive: [{
	            breakpoint: 1600,
	            settings: {
	                centerPadding: "300px"
	            }
	        }, {
	            breakpoint: 1200,
	            settings: {
	                centerPadding: "125px"
	            }
	        }, {
	            breakpoint: 991,
	            settings: {
	                centerPadding: "125px"
	            }
	        }, {
	            breakpoint: 768,
	            settings: {
	                centerPadding: "27px"
	            }
	        }]
		});

		// Show the active item on document ready
		$('.team-carousel .slick-current .member-info').css('opacity', '1');

		// On before slide change
		$('.team-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$('.slick-current .member-info').css('opacity', '0');
		});

		// On after slide change
		$('.team-carousel').on('afterChange', function(event, slick, currentSlide){
			$('.slick-current .member-info').css('opacity', '1');
		});
	}


	//Load more button

	if ($('.load-more').length ) {
		$('.load-more').click(function(e) {
			e.preventDefault();
			$(this).find('i').removeClass('fa-ellipsis-h').addClass('fa-circle-o-notch fa-spin fa-fw');
			return false;
		});
	}
 

	// Google maps

	if ($('#map').length) {
		google.maps.event.addDomListener(window, 'load', initialize_map('#map'));
	}

    if ($('a.lightbox').length) {
	    $('a.lightbox').each(function() {
	    	$(this).magnificPopup({
	    		type: 'image'
	    	});
	    });
	}
  
  	//Change view
  	
  	if ($('.change-view').length) {
      $('.change-view').on('click', function() {
        var view = $(this).data('view'),
            url = document.URL,
            hasParams = url.indexOf('?') > -1;

        if (hasParams) {
          window.location = replaceUrlParam(url, 'view', view);
        } else {
          window.location = url + '?view=' + view;
        }
        return false;
      });
    }
  
  	
  	//Account pages
  	
      function showRecoverPasswordForm() {
        $('#RecoverPasswordForm').show();
        $('#CustomerLoginForm').hide();
      }

      function hideRecoverPasswordForm() {
        $('#RecoverPasswordForm').hide();
        $('#CustomerLoginForm').show();
      }

      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
      });

      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
      });
  
  
  	//Instafeed
    var feed = new Instafeed({
        get: "user",
        userId: 207642893,
        limit: 50,
        accessToken: "2270218888.cf0499d.f0939b7decfa4a7da0e864bda30d1a23",
        resolution: "thumbnail",
        after: function() {
            $("#instafeed").simplyScroll({
                speed: 3,
                frameRate: 25,
              	auto: false,
                orientation: "horizontal",
                direction: "forwards",
                customClass: "instagram_scroller"
            });
        }
    });
    feed.run();
 
  
});


function alignVertical() {

	$('.align-vertical').each(function(){
		var that = $(this);
			height = that.height(),
			parentHeight = that.parent().height(),
			padAmount = (parentHeight / 2) - (height/2);
		if (that.hasClass('hero')) {
			that.css('padding-top', padAmount+20);
		} else {
			that.css('padding-top', padAmount);
		}
	});
	
}

function halfMarginTop() {

	$('.half-margin-top').each(function(){
		var that = $(this);
			height = that.height()/2+40,
		
		that.css('margin-top', -height);
	});
	
}

function initialize_map(id) {

	var latitude = $(id).data('lat'),
		longitude = $(id).data('long');
  	var mapOptions = {
	    zoom: 16,
	    scrollwheel: false,
	    panControl: false,
	    zoomControl: false,
	    scaleControl: false,
	    disableDefaultUI: true,
	    center: new google.maps.LatLng(latitude, longitude)
  	}
  	var map = new google.maps.Map(document.getElementById('map'), mapOptions);
  	map.set('styles', [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]);


  	var image = '//cdn.shopify.com/s/files/1/1009/2710/t/3/assets/marker.png?9389344609473927018';
  	var myLatLng = new google.maps.LatLng(latitude, longitude);
  	var marker = new google.maps.Marker({
	    position: myLatLng,
	    map: map,
	    icon: image
  	});
}